<div *ngIf="product.ysRating >= 0 || product.ysRatingComments" class="bg-light p-0 px-xl-4 pt-xl-4 pb-xl-0">
    <div class="bg-primary">
        <div class="ff-spectral fs-6 fw-bold text-white text-center d-md-none pt-3 mb-0">
            Our Team says:
        </div>
        <div class="px-5 pt-4 pb-5 p-xl-4">
            <div class="row">
                <div class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-0">
                    <div *ngIf="product.ysRating >= 1 " class="row mb-3 mb-xl-0">
                        <div class="col-12 col-xs-6 col-xl-12 d-flex justify-content-between justify-content-xl-start mb-3 mb-xs-0 mb-xl-3">
                            <ng-container *ngIf="product.ysRating === 1">
                                <img class="img-fluid me-1" [src]="'assets/images/ysRatingOn.png'"/>
                                <img class="img-fluid me-1" [src]="'assets/images/ysRatingOff.png'"/>
                                <img class="img-fluid" [src]="'assets/images/ysRatingOff.png'"/>
                            </ng-container>
                            <ng-container *ngIf="product.ysRating === 2">
                                <img class="img-fluid me-1" [src]="'assets/images/ysRatingOn.png'"/>
                                <img class="img-fluid me-1" [src]="'assets/images/ysRatingOn.png'"/>
                                <img class="img-fluid" [src]="'assets/images/ysRatingOff.png'"/>
                            </ng-container>
                            <ng-container *ngIf="product.ysRating === 3">
                                <img class="img-fluid me-1" [src]="'assets/images/ysRatingOn.png'"/>
                                <img class="img-fluid me-1" [src]="'assets/images/ysRatingOn.png'"/>
                                <img class="img-fluid" [src]="'assets/images/ysRatingOn.png'"/>
                            </ng-container>
                        </div>
                        <div class="col-12 col-xs-6 col-xl-12 d-flex flex-column flex-xl-row
                                justify-content-center justify-content-xl-start align-items-xl-center">
                            <span class="d-none d-xl-block ff-spectral text-white small op-5 ms-xl-2 me-xl-2">Yorkstone rating</span>
                            <span class="ff-spectral fs-4 fw-bolder text-white text-center text-sm-start ms-4 ms-xl-0" *ngIf="product.ysRating === 1"> Great Value</span>
                            <span class="ff-spectral fs-4 fw-bolder text-white text-center text-sm-start ms-4 ms-xl-0" *ngIf="product.ysRating === 2"> Very Good</span>
                            <span class="ff-spectral fs-4 fw-bolder text-white text-center text-sm-start ms-4 ms-xl-0" *ngIf="product.ysRating === 3"> Excellent</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-6 offset-lg-3 col-xl-6 offset-xl-0">
                    <div *ngIf="product.ysRatingComments" class="d-flex flex-column">
                        <span class="d-none d-xxl-block ff-spectral text-white small op-5 mb-1 mb-xl-2">Our team says:</span>
                        <span class="text-white text-center text-xl-start lh--rating">"{{product.ysRatingComments}}"</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
